// extracted by mini-css-extract-plugin
export default {"wrapper":"TransactionsHistory_wrapper--HZx","skeletNameItem":"TransactionsHistory_skeletNameItem--qDD","skeletWrapper":"TransactionsHistory_skeletWrapper--LcB"};